<app-header></app-header>
<app-banner></app-banner>
<app-brand></app-brand>
<app-course></app-course>
<app-about></app-about>
<app-why-choose></app-why-choose>
<app-events></app-events>
<app-footer></app-footer>